import {GeneralSettingsState, SET_GENERAL_SETTINGS, SetGeneralSettings} from "../types/GeneralSettingsTypes";

export const setGeneralSettings = (
    data: GeneralSettingsState
): SetGeneralSettings => ({
    type: SET_GENERAL_SETTINGS,
    data: data
});